import React from 'react';
import T from 'prop-types';
// hooks
import { useDropdownActions } from 'hooks/useDropdownContext';
// components
import StatusBadge from 'components/StatusBadge/StatusBadge';
import { ThreeDotsBtn } from 'components/Button';
import EffectiveDates from 'components/TreatmentProtocols/EffectiveDates';
import { FormattedMessage } from 'react-intl';
// styles
import styles from './TreatmentProtocolProfile.module.scss';

const TreatmentProtocolProfileHeader = ({
  treatmentProtocol,
  options,
  showEffectiveDates,
}) => {
  const { openDropdown } = useDropdownActions();

  return (
    <div className={styles['treatment-protocol-header']}>
      <div className={styles['treatment-protocol-information']}>
        <h1 className="lighter inline-block mr-5 ml-10">{treatmentProtocol.name}</h1>
        <StatusBadge className="ml-10" status={treatmentProtocol.active ? 'active' : 'disabled'} />
        {showEffectiveDates && (
          <span className="ml-20">
            <FormattedMessage id="general.effectiveDates" />
            {': '}
            <EffectiveDates
              className="semibold"
              startDate={treatmentProtocol.effective_start_date}
              endDate={treatmentProtocol.effective_end_date}
            />
          </span>
        )}
      </div>
      {!!options.length && (
        <div className={styles['header-dropdown']}>
          <ThreeDotsBtn onClick={(e) => openDropdown(e, options)} />
        </div>
      )}
    </div>
  );
};

TreatmentProtocolProfileHeader.propTypes = {
  treatmentProtocol: T.object.isRequired,
  options: T.array.isRequired,
  showEffectiveDates: T.bool,
};

TreatmentProtocolProfileHeader.defaultProps = {
  showEffectiveDates: false,
};

export default TreatmentProtocolProfileHeader;
